import {useEffect, useRef} from "react";
import useToggle from "v4/hooks/useToggle";

export default function usePolDropdown(extraRef = null) {
    const [isOpen, toggleIsOpen] = useToggle();
    const [isHovered, toggleIsHovered] = useToggle();
    const containerRef = useRef(null);

    const handleMouseEnter = () => {
        toggleIsHovered(true);
    }

    const handleMouseLeave = () => {
        toggleIsHovered(false);
    }

    useEffect(() => {
        if (!isOpen) return;

        const handleClickOutside = (e) => {
            const inContainer = containerRef.current?.contains(e.target);
            const inExtra = extraRef?.current?.contains(e.target);
            if (!inContainer && !inExtra) {
                toggleIsOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);

        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen, toggleIsOpen, extraRef]);

    return {
        isOpen,
        toggleIsOpen,
        isHovered,
        handleMouseEnter,
        handleMouseLeave,
        containerRef,
    }
}
